'use client'

import color from '@ui/style/color.theme'

interface Icon24LikeProps {
	isLiked?: boolean
}
export const Icon24Like = ({ isLiked }: Icon24LikeProps) => {
	const colorValue = isLiked ? color.colPointBlue : color.colBlack
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="25"
			height="24"
			viewBox="0 0 25 24"
			fill="none"
		>
			<path
				d="M8.5 10.1852L11.2026 5.72628C11.4759 5.27539 11.9649 5 12.4921 5V5C13.3249 5 14 5.67509 14 6.50787L14 10.1852L16.9689 10.1852C18.2605 10.1852 19.2134 11.3911 18.9147 12.6477L17.7702 17.4625C17.556 18.3638 16.7508 19 15.8244 19L8.5 19L8.5 10.1852Z"
				stroke={colorValue}
				strokeWidth="1.5"
			/>
			<rect x="4.5" y="10" width="4" height="9" stroke={colorValue} strokeWidth="1.5" />
		</svg>
	)
}
